/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Col, Form, FormGroup, Input, InputGroup, Row, Table } from 'reactstrap';
import { JhiItemCount, JhiPagination, Translate, getPaginationState, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { ASC, DESC, ITEMS_PER_PAGE, SORT } from 'app/shared/util/pagination.constants';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities, searchEntities } from './physio-therapist.reducer';

export const PhysioTherapist = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [search, setSearch] = useState('');
  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getPaginationState(pageLocation, ITEMS_PER_PAGE, 'id'), pageLocation.search),
  );

  const physioTherapistList = useAppSelector(state => state.physioTherapist.entities);
  const loading = useAppSelector(state => state.physioTherapist.loading);
  const totalItems = useAppSelector(state => state.physioTherapist.totalItems);

  const getAllEntities = () => {
    if (search) {
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    } else {
      dispatch(
        getEntities({
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
  };

  const startSearching = e => {
    if (search) {
      setPaginationState({
        ...paginationState,
        activePage: 1,
      });
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
    e.preventDefault();
  };

  const clear = () => {
    setSearch('');
    setPaginationState({
      ...paginationState,
      activePage: 1,
    });
    dispatch(getEntities({}));
  };

  const handleSearch = event => setSearch(event.target.value);

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort, search]);

  useEffect(() => {
    const params = new URLSearchParams(pageLocation.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [pageLocation.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = paginationState.sort;
    const order = paginationState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    }
    return order === ASC ? faSortUp : faSortDown;
  };

  return (
    <div>
      <h2 id="physio-therapist-heading" data-cy="PhysioTherapistHeading">
        <Translate contentKey="tinyMedicRestApp.physioTherapist.home.title">Physio Therapists</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="tinyMedicRestApp.physioTherapist.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link to="/physio-therapist/new" className="btn btn-primary jh-create-entity" id="jh-create-entity" data-cy="entityCreateButton">
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="tinyMedicRestApp.physioTherapist.home.createLabel">Create new Physio Therapist</Translate>
          </Link>
        </div>
      </h2>
      <Row>
        <Col sm="12">
          <Form onSubmit={startSearching}>
            <FormGroup>
              <InputGroup>
                <Input
                  type="text"
                  name="search"
                  defaultValue={search}
                  onChange={handleSearch}
                  placeholder={translate('tinyMedicRestApp.physioTherapist.home.search')}
                />
                <Button className="input-group-addon">
                  <FontAwesomeIcon icon="search" />
                </Button>
                <Button type="reset" className="input-group-addon" onClick={clear}>
                  <FontAwesomeIcon icon="trash" />
                </Button>
              </InputGroup>
            </FormGroup>
          </Form>
        </Col>
      </Row>
      <div className="table-responsive">
        {physioTherapistList && physioTherapistList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="tinyMedicRestApp.physioTherapist.id">Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('education')}>
                  <Translate contentKey="tinyMedicRestApp.physioTherapist.education">Education</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('education')} />
                </th>
                <th className="hand" onClick={sort('training')}>
                  <Translate contentKey="tinyMedicRestApp.physioTherapist.training">Training</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('training')} />
                </th>
                <th className="hand" onClick={sort('experience')}>
                  <Translate contentKey="tinyMedicRestApp.physioTherapist.experience">Experience</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('experience')} />
                </th>
                <th className="hand" onClick={sort('achievements')}>
                  <Translate contentKey="tinyMedicRestApp.physioTherapist.achievements">Achievements</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('achievements')} />
                </th>
                <th className="hand" onClick={sort('timestampentry')}>
                  <Translate contentKey="tinyMedicRestApp.physioTherapist.timestampentry">Timestampentry</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('timestampentry')} />
                </th>
                <th className="hand" onClick={sort('microSec')}>
                  <Translate contentKey="tinyMedicRestApp.physioTherapist.microSec">Micro Sec</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('microSec')} />
                </th>
                <th className="hand" onClick={sort('lastupdated')}>
                  <Translate contentKey="tinyMedicRestApp.physioTherapist.lastupdated">Lastupdated</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('lastupdated')} />
                </th>
                <th className="hand" onClick={sort('active')}>
                  <Translate contentKey="tinyMedicRestApp.physioTherapist.active">Active</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('active')} />
                </th>
                <th className="hand" onClick={sort('cursor')}>
                  <Translate contentKey="tinyMedicRestApp.physioTherapist.cursor">Cursor</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('cursor')} />
                </th>
                <th className="hand" onClick={sort('name')}>
                  <Translate contentKey="tinyMedicRestApp.physioTherapist.name">Name</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('name')} />
                </th>
                <th className="hand" onClick={sort('email')}>
                  <Translate contentKey="tinyMedicRestApp.physioTherapist.email">Email</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('email')} />
                </th>
                <th className="hand" onClick={sort('visitCharge')}>
                  <Translate contentKey="tinyMedicRestApp.physioTherapist.visitCharge">Visit Charge</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('visitCharge')} />
                </th>
                <th className="hand" onClick={sort('age')}>
                  <Translate contentKey="tinyMedicRestApp.physioTherapist.age">Age</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('age')} />
                </th>
                <th className="hand" onClick={sort('gender')}>
                  <Translate contentKey="tinyMedicRestApp.physioTherapist.gender">Gender</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('gender')} />
                </th>
                <th className="hand" onClick={sort('mobile')}>
                  <Translate contentKey="tinyMedicRestApp.physioTherapist.mobile">Mobile</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('mobile')} />
                </th>
                <th className="hand" onClick={sort('dateOfBirth')}>
                  <Translate contentKey="tinyMedicRestApp.physioTherapist.dateOfBirth">Date Of Birth</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('dateOfBirth')} />
                </th>
                <th className="hand" onClick={sort('bloodGroup')}>
                  <Translate contentKey="tinyMedicRestApp.physioTherapist.bloodGroup">Blood Group</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('bloodGroup')} />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.physioTherapist.tmUser">Tm User</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.physioTherapist.contactCode">Contact Code</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.physioTherapist.hospital">Hospital</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {physioTherapistList.map((physioTherapist, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/physio-therapist/${physioTherapist.id}`} color="link" size="sm">
                      {physioTherapist.id}
                    </Button>
                  </td>
                  <td>{physioTherapist.education}</td>
                  <td>{physioTherapist.training}</td>
                  <td>{physioTherapist.experience}</td>
                  <td>{physioTherapist.achievements}</td>
                  <td>{physioTherapist.timestampentry}</td>
                  <td>{physioTherapist.microSec}</td>
                  <td>{physioTherapist.lastupdated}</td>
                  <td>{physioTherapist.active ? 'true' : 'false'}</td>
                  <td>{physioTherapist.cursor}</td>
                  <td>{physioTherapist.name}</td>
                  <td>{physioTherapist.email}</td>
                  <td>{physioTherapist.visitCharge}</td>
                  <td>{physioTherapist.age}</td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.Gender.${physioTherapist.gender}`} />
                  </td>
                  <td>{physioTherapist.mobile}</td>
                  <td>{physioTherapist.dateOfBirth}</td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.BloodGroup.${physioTherapist.bloodGroup}`} />
                  </td>
                  <td>{physioTherapist.tmUser ? physioTherapist.tmUser.id : ''}</td>
                  <td>
                    {physioTherapist.contactCode ? (
                      <Link to={`/contact-details/${physioTherapist.contactCode.id}`}>{physioTherapist.contactCode.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {physioTherapist.hospital ? (
                      <Link to={`/hospital/${physioTherapist.hospital.id}`}>{physioTherapist.hospital.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button
                        tag={Link}
                        to={`/physio-therapist/${physioTherapist.id}`}
                        color="info"
                        size="sm"
                        data-cy="entityDetailsButton"
                      >
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/physio-therapist/${physioTherapist.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        onClick={() =>
                          (window.location.href = `/physio-therapist/${physioTherapist.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`)
                        }
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="tinyMedicRestApp.physioTherapist.home.notFound">No Physio Therapists found</Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div className={physioTherapistList && physioTherapistList.length > 0 ? '' : 'd-none'}>
          <div className="justify-content-center d-flex">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </div>
          <div className="justify-content-center d-flex">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default PhysioTherapist;
